'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationSignupSimpleCtrl', function ($scope, $uibModalInstance, regexStrings,
                                                          $state, OrganizationSettings, $interval,
                                                          $timeout, ServerUrls, Session, $uibModal,
                                                          Registration, security, Angularytics, toastr,
                                                          SubscriptionPlansService, LibraryStore,
                                                          InternalAnalyticsService, ReferralActions, uuid4) {

      var referralCode, referralActionId, theCurrentTimezone;

      $scope.state = {
        enterVerificationMessage: 'Great! Check your email (or text messages) for a 6 digit code from us and enter it below.',
        panels: {
          enterContactInfo: true,
          enterVerificationCode: false,
          enterPassword: false,
          enterApp: false
        },
        formData: {
          email: null,
          phone: null,
          code: null,
          password: null,
          passwordConf: null
        },
        referrals: {
          companyName: null,
          companyEmail: null,
          companyPhone: null,
          referralCode: null
        },
        requestingCode: false,
        codeVerified: false,
        generatingSandbox: false,
        couponCodeValid: true,
      };

      if (window.Cookies) {
        console.log('referralId', Cookies.get('referralId'));
        referralCode = Cookies.get('referralId');

        if (!_.isUndefined(referralCode)) {
          referralActionId = /^RA_([0-9]{8})$/ig.exec(referralCode);
          console.log(referralActionId);

          if (referralActionId.length >= 2) {
            referralActionId = parseInt(referralActionId[1]);
          }

          ReferralActions.getAlternatives(referralActionId)
            .then(function(referralActions) {
              $scope.matchingReferralAction = _.find(referralActions, {id: referralActionId});

              if ($scope.matchingReferralAction) {
                $scope.state.referrals.companyName = $scope.matchingReferralAction.store.chain_name + ' ' + $scope.matchingReferralAction.store.name;
                $scope.state.referrals.companyEmail = $scope.matchingReferralAction.store.email;
                var fromPn = $scope.matchingReferralAction.store.phone_number;
                var pn = fromPn[2] + fromPn[3] + fromPn[4] + '-' + fromPn[5] + fromPn[6] + fromPn[7] + '-' + fromPn[8] + fromPn[9] + fromPn[10] + fromPn[11];
                $scope.state.referrals.companyPhone = pn;
              }

              $scope.alternativeReferralActions = _.where(referralActions, function(ra) {
                return ra.id !== referralActionId;
              });
            });
        }
      }

      Angularytics.trackEvent('Signup', 'signup-opened', referralCode);

      LibraryStore.load('jstz')
        .then(function() {
          var tempTz = jstz.determine().name();
          // console.log('tz', tempTz);

          if (tempTz === 'America/New_York') {
            theCurrentTimezone = 'Eastern Time (US & Canada)';
          } else if (tempTz === 'America/Chicago') {
            theCurrentTimezone = 'Central Time (US & Canada)';
          } else if (tempTz === 'America/Denver') {
            theCurrentTimezone = 'Mountain Time (US & Canada)';
          } else if (tempTz === 'America/Los_Angeles') {
            theCurrentTimezone = 'Pacific Time (US & Canada)';
          } else {
            theCurrentTimezone = undefined;
          }
          // console.log('theCurrentTimezone', theCurrentTimezone);
        }, function() {});

      Session.generateNewSessionIdIfNotSet();
      $scope.serverUrl = ServerUrls.current.railsApi;
      $scope.access_token = Session.getAccessToken();
      $scope.modalInstance = $uibModalInstance;
      $scope.regexStrings = regexStrings;

      $scope.goToEnterVerification = function() {
        $scope.state.panels.enterContactInfo = false;
        $scope.state.panels.enterVerificationCode = true;
        $scope.state.panels.enterPassword = false;

        $('.mini_modal_signup .enter-verification-code-panel #ActivationCode').focus();
      };

      $scope.requestCode = function() {
        var data = {
          email: $scope.state.formData.email
        };

        if ($scope.state.formData.phone) {
          data.phone_number = $scope.state.formData.phone;
        }

        $scope.state.requestingCode = true;
        Registration.requestVerificationCode(data)
          .then(function() {
            // customize the enterVerificationMessage to help them make sure they put in the correct contact details.
            $scope.state.enterVerificationMessage = 'Great! ';

            if (data.phone_number) {
              $scope.state.enterVerificationMessage += 'We just sent a 6 digit code to ' + data.phone_number + ' and ' + data.email + '. ';
            } else {
              $scope.state.enterVerificationMessage += 'We just sent a 6 digit code to ' + data.email + '. ';
            }

            $scope.state.enterVerificationMessage += 'Please enter the code below.';

            $scope.state.requestingCode = false;
            $scope.state.panels.enterContactInfo = false;
            $scope.state.panels.enterPassword = true;
            $scope.state.panels.enterVerificationCode = false;

            $('.mini_modal_signup .enter-password-panel #Password').focus();
          }, function() {
            $scope.state.requestingCode = false;
            console.log('Failed to retrieve verification code');
          });
      };

      $scope.sendRequest = function() {
        var pn = $scope.state.formData.phone || null;

        if (pn) {
          // remove all non-numeric characters
          pn = pn.replace(/[^0-9]+/ig, '')
        }

        var data = {
          user: {
            first_name: 'Demo',
            last_name: 'Admin',
            email: $scope.state.formData.email,
            password: $scope.state.formData.password,
            password_confirmation: $scope.state.formData.passwordConf,
            phone_number: pn
          },
          organization_config: {
            timezone: theCurrentTimezone || 'Eastern Time (US & Canada)'
          },
          plan: 'SA-PLUS-DEMO',
          signup_token: $scope.state.formData.code,
        };

        data.signup_code = $scope.state.formData.coupon ? $scope.state.formData.coupon : undefined
        data.referral_code = $scope.state.referrals.referralCode ? $scope.state.referrals.referralCode : undefined

        $scope.state.generatingSandbox = true;
        Registration.createUserWithOrganization(data)
            .then(function(newUser) {
              $scope.userOrgCreateStatus = true;

              InternalAnalyticsService.captureAnalytic('signupWizard:registrationComplete', {
                email: $scope.state.formData.email,
                organization_id: newUser.memberships[0].organization.id
              });

              // get rid of that cookie! Now that they've signed up, don't have it repeat.
              // Especially needed for a computer used to sign up multiple stores...
              if (window.Cookies && Cookies && Cookies.get('referralId')) {
                Cookies.remove('referralId');
              }

              Angularytics.trackEvent('Signup', 'org-creation-success', newUser.memberships[0].organization.id);

              $('html').append('<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/961793915/?label=rvfGCPTw01cQ-57PygM&guid=ON&script=0"/>');

              // get an access token automatically... we just asked them for their password so we may as well

              $timeout(function() {
                security.login($scope.state.formData.email, data.user.password, true)
                    .then(function(data) {
                      if( data.status === 401 ) {
                        console.log('incorrect username or password');
                        $scope.status = 'credFail';
                        $scope.state.waitingForFinish = false;
                      }
                      else if (data.status > 401 || data.status === 400) {
                        $scope.state.waitingForFinish = false;
                        console.log('server problems');
                      }
                      else {
                        console.log('successful login');
                        Session.setMe(newUser);
                        $scope.state.generatingSandbox = false;

                        $scope.state.mediatorModalInstance = $uibModal.open({
                          templateUrl: 'views/organizationSignupSimpleMediator.html',
                          controller: 'OrganizationSignupSimpleMediatorCtrl',
                          size: 'wizard',
                          keyboard: false,
                          backdrop: 'static'
                        });

                        $uibModalInstance.close();
                      }
                    });
              }, 0);

            },
            function(response) {
              $scope.state.generatingSandbox = false;
              console.log('errors!');
              console.log(response);
              $scope.userOrgCreateStatus = false;
              $scope.errors = response.data.errors;
              $scope.state.waitingForFinish = false;
              toastr.error('Company creation failed. Please try again.', 'Error');
            });
      };

      var uuidToWatch = null
      $scope.$watch('state.formData.coupon', _.debounce(function (newVal, oldVal) {
        if (!newVal && newVal !== '') {
          return
        }
        uuidToWatch = uuid4.generate()
        window.dataLayer.push({ event: 'sa_org_signup_code_validate', signupCode: newVal, eventUuid: uuidToWatch })
      }, 100))

      setInterval(function () {
        if (!uuidToWatch) {
          return
        }
        var replyWeWant = _.find(window.dataLayerReplies, { eventUuid: uuidToWatch })
        if (window.dataLayerReplies.length > 0 && replyWeWant) {
          // Pull the next event of the uuids we want from the replies array
          var toProcess = window.dataLayerReplies.shift()
          uuidToWatch = null
          $scope.$apply(function () {
            $scope.state.latestCoupon = toProcess.signupCode !== '' ? toProcess : null
            $scope.state.couponCodeValid = toProcess.valid || toProcess.signupCode === ''
          })
        }
      }, 100)

      $scope.enterContactInfoAgain = function() {
        $scope.state.panels.enterVerificationCode = false;
        $scope.state.panels.enterContactInfo = true;
        $scope.state.panels.enterPassword = false;

        $scope.state.formData.code = '';
        $scope.state.formData.password = '';
        $scope.state.formData.passwordConf = '';

        $('.mini_modal_signup .enter-contact-info-panel #UserEmail').focus();
      };

      $scope.close = function() {
        $uibModalInstance.close('close');
      };

    });
